import { RootState } from 'store';

export function getPartnerStatsSelector({ partnerStats }: RootState) {
  return partnerStats.data;
}